import "./consejos.css";

export default function Consejos() {
  const consejos = [
    {
      titulo: "Ácido fólico",
      descripcion: "Consumir alimentos ricos en ácido fólico es clave para la salud celular y la prevención de deficiencias nutricionales, especialmente en mujeres en edad fértil.",
      imagen: "/images/nutricion/nutricion1.webp"
    },
    {
      titulo: "Saltar la cuerda",
      descripcion: "Ejercicio cardiovascular efectivo que mejora la resistencia, quema calorías y tonifica piernas y glúteos.",
      imagen: "/images/entrenamiento/entreno2.webp"
    }, 
    {
      titulo: "Frutas bajas en azúcar",
      descripcion: "Consumir frutas bajas en azúcar como frutillas, moras o kiwi aporta vitaminas y fibra sin elevar demasiado el índice glucémico.",
      imagen: "/images/nutricion/nutricion3.webp"
    },
  ];

  return (
    <section className="consejos">
      <h2>Consejos para tu bienestar</h2>
      <div className="consejos-grid">
        {consejos.map((c, i) => (
          <div key={i} className="consejo-card">
            <img src={c.imagen} alt={c.titulo} />
            <h3>{c.titulo}</h3>
            <p>{c.descripcion}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
